import React from "react";

const Cart = () => {
  return (
    <div>
      <div className="cart-icon">
        <span className="cart-items">1</span>
        <span>
          <i className="ri-luggage-cart-line"></i>
        </span>
      </div>
    </div>
  );
};

export default Cart;
